import React from 'react';
import {
    Container as MuiContainer
} from '@mui/material';

export default function Container({ children }: { children: React.ReactNode }) {
    return (
        <MuiContainer maxWidth={false} sx={{ maxWidth: '1800px', mt: 4, mb: 4 }}>
            {children}
        </MuiContainer>
    );
}
